import http from "./http_common";
import _ from "lodash";

class DeviceService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");
  }

  GetPatientDevices(payload) {
    var queryString = this.queryString(payload);
    return http.get(`/patientDevices/list/filter?${queryString}`);
  }

  GetGarminDevices(payload) {
    var queryString = this.queryString(payload);
    return http.get(`/webhooks/garmin/list?${queryString}`);
  }
  DayStepDetails(payload) {
    var queryString = this.queryString(payload);
    return http.get(`/webhooks/garmin/dayStepDetails?${queryString}`);
  }
}

export default new DeviceService();
